import React from 'react';
import { AddItemButton } from './AddItemButton';
import { useLocale } from '../contexts/LocaleContext';

interface DeskNotesActionsProps {
  disabled: boolean;
  onCreate: () => void;
}

export const DeskNotesActions: React.FC<DeskNotesActionsProps> = ({ disabled, onCreate }) => {
  const { t } = useLocale();

  return (
    <AddItemButton
      onClick={onCreate}
      disabled={disabled}
      label={t('create_note') || 'Create note'}
    />
  );
};
